import { type StateCreator, create } from "zustand";
import { devtools /*persist*/ } from "zustand/middleware";

interface TimeState {
	currentTime: number;
	setCurrentTime: (currentTime: number) => void
}

type Store = StateCreator<TimeState>;

const store: Store = (set) => ({
	currentTime: 0,
	
	setCurrentTime(currentTime) {
		set((state) => {
			return { ...state, currentTime };
		});
	},
});

export const useStore = create<TimeState>()(
	devtools(
		// persist(store, {
		// 	name: "admin-storage",
		// }),
		store,
		{
			enabled: import.meta.env.DEV,
			name: "time-store",
		},
	),
);

export const useTimeStore = () => useStore((state) => state);
